import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Output, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomService } from '@portal-core/general/services/dom.service';
import { ToolbarPopupPluginViewComponentBase } from '@portal-core/text-editor/plugin-views/util/toolbar-popup-plugin-view-component.base';
import { FAILED_MATHML_CONVERSION_ERROR, LOSSY_MATHML_CONVERSION_WARNING } from '@portal-core/ui/equation/util/equation-node';
import { SnackBarErrorComponent } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.component';
import { SnackBarWarningComponent } from '@portal-core/ui/snack-bar/components/snack-bar-warning/snack-bar-warning.component';

@Component({
  selector: 'mc-equation-toolbar-popup-plugin-view',
  templateUrl: './equation-toolbar-popup-plugin-view.component.html',
  styleUrls: ['./equation-toolbar-popup-plugin-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EquationToolbarPopupPluginViewComponent extends ToolbarPopupPluginViewComponentBase {
  /**
   * Whether the selected equation supports editing — set by
   * EquationToolbarPopupPluginView.updateComponent(). Disables (not hides) the Edit button for a
   * MathML equation (PBI #186777, per team discussion — an always-visible-but-disabled button with
   * an explanatory tooltip reads clearer than a button that silently disappears), which stays
   * deletable either way.
   */
  canEdit = true;

  @Output() convertToLatex: EventEmitter<void> = new EventEmitter<void>();

  constructor(changeDetectorRef: ChangeDetectorRef, domService: DomService, @Inject(DOCUMENT) document: Document, private snackBar: MatSnackBar) {
    super(changeDetectorRef, domService, document);
  }

  onConvertToLatex() {
    this.convertToLatex.emit();
  }

  /** Called by EquationToolbarPopupPluginView after a conversion isFailedMathMlConversion() flags. */
  showFailedConversionError() {
    this.snackBar.openFromComponent(SnackBarErrorComponent, { data: FAILED_MATHML_CONVERSION_ERROR });
  }

  /** Called by EquationToolbarPopupPluginView after a conversion isLikelyLossyMathMlConversion() flags. */
  showLossyConversionWarning() {
    this.snackBar.openFromComponent(SnackBarWarningComponent, { data: LOSSY_MATHML_CONVERSION_WARNING });
  }
}
